import { useTranslation } from "react-i18next";

import { useActions } from "../../../../hooks/useActions";
import { useTypedSelector } from "../../../../hooks/useTypedSelector";
import useMobileScreen from "../../../../hooks/useMobileScreen";
import { breakpoints } from "../../../../constants";
import { CurrentPerson } from "../../../../models/CurrentPerson";
import {
  ListViewHeaderCell,
  ListViewHeaderIconSpacer,
  ListViewHeaderRow,
  ListViewStickyHeader,
} from "../../../../share/searchResults";
import SearchResultsResponsive from "../../../../share/searchResults/SearchResultsResponsive";
import PersonsSearchResultItem from "./PersonsSearchResultItem";

const PersonSearchResults = () => {
  const {
    setCleanAllPersonFilters,
    getDefaultPersonResult,
    refreshFeedForPersonsSearchResults,
  } = useActions();
  const { persons, count } = useTypedSelector((state) => state.mapPersonInfo);
  const { isListViewActive } = useTypedSelector((state) => state.mapInterface);

  const isMobile = useMobileScreen(breakpoints.medium);
  const shouldRenderHeader =
    isListViewActive && !isMobile && Boolean(persons && persons.length > 0);

  const { t } = useTranslation("translation", {
    keyPrefix: "mainPage.mapFilters.listView.headers.persons",
  });

  const handleClean = () => {
    setCleanAllPersonFilters();
    getDefaultPersonResult();
  };

  return (
    <SearchResultsResponsive
      onClearAllFilters={handleClean}
      count={count}
      handleLoadFeed={refreshFeedForPersonsSearchResults}
    >
      {shouldRenderHeader && (
        <ListViewStickyHeader>
          <ListViewHeaderRow>
            <ListViewHeaderIconSpacer aria-hidden="true" />
            <ListViewHeaderCell flex="2 1 320px">
              {t("person")}
            </ListViewHeaderCell>
            <ListViewHeaderCell flex="1 1 200px">
              {t("status")}
            </ListViewHeaderCell>
            <ListViewHeaderCell flex="1 1 200px">
              {t("registrationDate")}
            </ListViewHeaderCell>
          </ListViewHeaderRow>
        </ListViewStickyHeader>
      )}
      {persons?.map((mapObject: CurrentPerson) => (
        <PersonsSearchResultItem key={mapObject.hash} mapObject={mapObject} />
      ))}
    </SearchResultsResponsive>
  );
};

export default PersonSearchResults;
